import { render, staticRenderFns } from "./addproprietor.vue?vue&type=template&id=04062e50&scoped=true&"
import script from "./addproprietor.vue?vue&type=script&lang=js&"
export * from "./addproprietor.vue?vue&type=script&lang=js&"
import style0 from "./addproprietor.vue?vue&type=style&index=0&id=04062e50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04062e50",
  null
  
)

export default component.exports